module.exports = __webpack_public_path__ + "static/media/skinnyLanding1.70877093.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/skinnyLanding1.png
// module id = 1232
// module chunks = 0